import logoUrl from './favelafood-logo.svg';

/**
 * The favelaFOOD wordmark (the mockup's stacked "favela/FOOD" lockup, exported
 * as an SVG). Fill is the light `#FFECEC`, so it reads on the red login hero and
 * the dark shell sidebar alike. Size via `className` (e.g. `h-9 w-auto`).
 */
export function MerchantLogo({ className }: { className?: string }): JSX.Element {
  return <img src={logoUrl} alt="favelaFOOD" className={className} />;
}
